var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFollowoneAi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 446.23 104.02",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        font-family: Lato-Black, Lato;\r\n        font-size: 49.93px;\r\n        font-weight: 800;\r\n      }\r\n\r\n      .cls-1, .cls-2, .cls-3 {\r\n        fill: #444545;\r\n      }\r\n\r\n      .cls-3 {\r\n        font-family: Lato-Semibold, Lato;\r\n        font-size: 69.64px;\r\n        font-weight: 600;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(-5.95 73.95)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    xmlSpace: "preserve"
  }, "Followone   ")), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M324.36,30.12c0,4.48-3.52,7.99-8.09,7.99s-8.14-3.51-8.14-7.99,3.61-7.9,8.14-7.9,8.09,3.52,8.09,7.9ZM310.16,30.12c0,3.52,2.6,6.31,6.16,6.31s6.02-2.79,6.02-6.26-2.55-6.36-6.07-6.36-6.11,2.84-6.11,6.3ZM315.02,34.27h-1.83v-7.9c.72-.15,1.73-.24,3.03-.24,1.49,0,2.17.24,2.74.58.43.34.77.96.77,1.74,0,.87-.67,1.54-1.64,1.83v.1c.77.29,1.2.87,1.44,1.93.24,1.2.39,1.69.58,1.98h-1.97c-.24-.29-.38-1.01-.63-1.93-.15-.87-.63-1.25-1.64-1.25h-.87v3.18ZM315.07,29.78h.87c1.01,0,1.83-.33,1.83-1.15,0-.72-.53-1.2-1.69-1.2-.48,0-.82.05-1.01.09v2.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M437.4,104.19h-86.06c-5.01,0-9.09-4.08-9.09-9.09V9.04c0-5.01,4.08-9.09,9.09-9.09h86.06c5.01,0,9.09,4.08,9.09,9.09v86.06c0,5.01-4.08,9.09-9.09,9.09ZM351.33,1.95c-3.91,0-7.09,3.18-7.09,7.09v86.06c0,3.91,3.18,7.09,7.09,7.09h86.06c3.91,0,7.09-3.18,7.09-7.09V9.04c0-3.91-3.18-7.09-7.09-7.09h-86.06Z"
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(367.18 71.05)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "AI")))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFollowoneAi);
export default __webpack_public_path__ + "static/media/followone-ai.6ab1d82273bd632d4452a2cb6254588a.svg";
export { ForwardRef as ReactComponent };